<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Deportistas por expirar</span>
</mat-toolbar>

<div class="margin-container apearAnimation">
  <div class="loading-indicator" *ngIf="isLoadingResults">
    <mat-spinner></mat-spinner>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>

  <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element" class="txtMayuscula">
          {{ element.nombre }}
          <br />
          <small>{{ element.documento }}</small>
        </td>
      </ng-container>

      <ng-container matColumnDef="disciplina">
        <th mat-header-cell *matHeaderCellDef>Disciplina</th>
        <td mat-cell *matCellDef="let element">{{ element.disciplina }}</td>
      </ng-container>

      <ng-container matColumnDef="contacto">
        <th mat-header-cell *matHeaderCellDef>Contacto</th>
        <td mat-cell *matCellDef="let element">{{ element.contacto }}</td>
      </ng-container>

      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef>Fecha fin servicio</th>
        <td mat-cell *matCellDef="let element">
          {{ element.fecha | date: "dd-MM-yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="dias">
        <th mat-header-cell *matHeaderCellDef>Días restantes</th>
        <td mat-cell *matCellDef="let element">
          <span class="inactivo"  *ngIf="element.dias <= 0">{{ element.dias }} [Inactivo] </span>
          <span class="alerta" *ngIf="element.dias > 0 && element.dias<=5">{{ element.dias }} </span>
          <span class="correcto" *ngIf="element.dias > 5">{{ element.dias }} </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      #paginator
      [length]="length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 100]"
      (page)="getServerData($event)"
    ></mat-paginator>
  </div>
</div>
